export const adminKeys = {
  users: (customer?: string) => ['admin_users', customer || ''] as const, // list of all items
};
